
import { ResponseData } from '@/datamodel/response-data'
import { PopAlertModel } from '@/datamodel/types'
import { DTBetParams } from '@/datamodel/urlparams/DTBetParams'
import { BetError, BET_TYPE, EventBuss } from '@/utils/constants'
import audioPlayer, { SOUNDKEY } from '@/utils/sounds'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { BetViewBaseMixin } from './bet-view-mixin'
import MobileBetArea from './m-bet-area.vue'
import { MemberLimit, Table } from 'vue'
import { saveBet } from '@/api'

@Options({
    components: {
        MobileBetArea
    }
})
export default class MobileDragonTigerBetView extends Mixins(BetViewBaseMixin) {
    redConfirmedTemp = 0
    blueConfirmedTemp = 0
    greenConfirmedTemp = 0

    message = ''
    showMessage = false

    @Getter('deskLimit') tableLimit!: MemberLimit
    @Getter('currentDesk') currentDesk!: Table
    @Getter('token') token!: string
    @Getter('memberId') memberId!: number

    @Action('placeDragontigerBet') placeDragontigerBet!: (
        model: DTBetParams
    ) => Promise<ResponseData>

    OnPlaceBet(betType: number): void {
        // if (this.chipValue <= 0) return

        // const toBetAmount = this.CheckIfValidBet(this.chipValue)

        // if (toBetAmount > 0) {
        //     this.selectedBetArea = betType

        //     switch (betType) {
        //         case BET_TYPE.TIGER: {
        //             // this.redTemp += toBetAmount

        //             const _rTotalR =
        //                 this.redTemp +
        //                 this.redConfirmed +
        //                 this.redConfirmedTemp +
        //                 toBetAmount
        //             const _bTotalR =
        //                 this.blueTemp +
        //                 this.blueConfrimed +
        //                 this.blueConfirmedTemp

        //             const _maxR = this.tableLimit.upLimit || 0

        //             if (Math.abs(_rTotalR - _bTotalR) > _maxR) {
        //                 this.toastCommonError(BetError.ABOVE_MAXIMUM)

        //                 // this.redTemp = _bTotalR + _maxR
        //             } else {
        //                 this.redTemp += toBetAmount
        //             }

        //             if (this.redTemp > 0) this.selectedBetArea = betType
        //             break
        //         }
        //         case BET_TYPE.DRAGON: {
        //             // this.blueTemp += toBetAmount

        //             const _rTotalB =
        //                 this.redTemp + this.redConfirmed + this.redConfirmedTemp
        //             const _bTotalB =
        //                 this.blueTemp +
        //                 this.blueConfrimed +
        //                 this.blueConfirmedTemp +
        //                 toBetAmount

        //             const _maxB = this.tableLimit.upLimit || 0

        //             if (Math.abs(_rTotalB - _bTotalB) > _maxB) {
        //                 this.toastCommonError(BetError.ABOVE_MAXIMUM)

        //                 // this.blueTemp = _rTotalB + _maxB
        //             } else {
        //                 this.blueTemp += toBetAmount
        //             }

        //             if (this.blueTemp > 0) this.selectedBetArea = betType
        //             break
        //         }
        //         case BET_TYPE.DT_TIE: {
        //             this.greenTemp += toBetAmount
        //             const _gTotal =
        //                 this.greenTemp +
        //                 this.greenConfrimed +
        //                 this.greenConfirmedTemp
        //             const _gMax = this.tableLimit.tieUpLimit || 0

        //             if (_gTotal > _gMax) {
        //                 this.toastCommonError(BetError.ABOVE_MAXIMUM)
        //                 this.greenTemp =
        //                     _gMax -
        //                     this.greenConfirmedTemp -
        //                     this.greenConfrimed
        //             }

        //             if (this.greenTemp > 0) this.selectedBetArea = betType
        //             break
        //         }
        //     }

        //     const totalTemp = this.greenTemp + this.redTemp + this.blueTemp
        //     this.$emit('on-bet-change', totalTemp)
        // }

        if (this.chipValue <= 0) return

        const toBetAmount = Math.floor(this.CheckIfValidBet(this.chipValue))

        if (toBetAmount > 0) {
            // this.selectedBetArea = betType

            switch (betType) {
                case BET_TYPE.TIGER: {
                    // this.redTemp += toBetAmount

                    const _rTotalR =
                        this.redTemp + this.redConfirmed + toBetAmount
                    // + this.redConfirmedTemp
                    const _bTotalR = this.blueTemp + this.blueConfrimed // +
                    // this.blueConfirmedTemp

                    const _maxR = this.tableLimit.upLimit || 0

                    if (Math.abs(_rTotalR - _bTotalR) > _maxR) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)

                        // if (Math.abs(_rTotalR - _bTotalR) - _maxR === 0)
                        //     this.redTemp = _bTotalR + _maxR
                        // else console.log('kk')
                    } else {
                        this.redTemp += toBetAmount
                    }

                    if (this.redTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.DRAGON: {
                    // this.blueTemp += toBetAmount

                    const _rTotalB = this.redTemp + this.redConfirmed
                    // + this.redConfirmedTemp
                    const _bTotalB =
                        this.blueTemp + this.blueConfrimed + toBetAmount
                    // this.blueConfirmedTemp

                    const _maxB = this.tableLimit.upLimit || 0

                    if (Math.abs(_rTotalB - _bTotalB) > _maxB) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)

                        // if (Math.abs(_rTotalB - _bTotalB) - _maxB === 0)
                        //     this.blueTemp = _rTotalB + _maxB
                        // else console.log('kkc')
                    } else {
                        this.blueTemp += toBetAmount
                    }

                    if (this.blueTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.DT_TIE: {
                    this.greenTemp += toBetAmount
                    const _gTotal =
                        this.greenTemp +
                        this.greenConfrimed +
                        this.greenConfirmedTemp
                    const _gMax = this.tableLimit.tieUpLimit || 0

                    if (_gTotal > _gMax) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.greenTemp =
                            _gMax -
                            this.greenConfirmedTemp -
                            this.greenConfrimed
                    }

                    if (this.greenTemp > 0) this.selectedBetArea = betType
                    break
                }
            }

            const totalTemp = this.greenTemp + this.redTemp + this.blueTemp
            this.$emit('on-bet-change', totalTemp)
        }
    }

    toastCommonError(_error: string): void {
        if (this.deskId !== -1) {
            this.PopMessage(_error)
        } else {
            const popError: PopAlertModel = {
                type: 0,
                header: '',
                message: _error,
                color: ''
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        }
    }

    PopMessage(msg: string): void {
        this.message = msg
        this.showMessage = true

        setTimeout(() => {
            this.showMessage = false
            this.message = ''
        }, 1000)
    }

    OnCancelBetTemp(): void {
        this.redTemp = 0
        this.blueTemp = 0
        this.greenTemp = 0
        this.selectedBetArea = -1
        this.$emit('on-bet-change', 0)
    }

    OnConfirmBet(): void {
        const popError: PopAlertModel = {
            type: 0,
            header: '',
            message: '',
            color: ''
        }

        let betError = this.checkRedAndBlueLimit()

        if (betError !== BetError.BET_OK) {
            popError.message = betError
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            return
        }

        betError = this.checkGreenLimit()

        if (betError !== BetError.BET_OK) {
            popError.message = betError
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            return
        }

        // everything is passed here call bet
        this.sendBetRequest()
    }

    CheckIfValidBet(tempBet: number): number {
        // const total = this.redTemp + this.blueTemp + this.greenTemp + tempBet
        // if (total <= this.betCoin) return tempBet
        // else {
        //     const popError: PopAlertModel = {
        //         type: 0,
        //         header: '',
        //         message: BetError.BALANCE_SHORT,
        //         color: ''
        //     }
        //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //     //@ts-ignore
        //     this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        //     const finalTemp = this.betCoin - (total - tempBet)
        //     if (finalTemp > 0) return finalTemp
        //     return 0
        // }

        const total = this.redTemp + this.blueTemp + this.greenTemp + tempBet

        if (total <= this.betCoin) return tempBet
        else {
            if (this.deskId !== -1) {
                this.PopMessage(BetError.BALANCE_SHORT)
            } else {
                const popError: PopAlertModel = {
                    type: 0,
                    header: '',
                    message: BetError.BALANCE_SHORT,
                    color: ''
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }
            const finalTemp = this.betCoin - (total - tempBet)
            if (finalTemp > 0) return finalTemp
            return 0
        }
    }

    checkRedAndBlueLimit(): string {
        const redTotal = this.redTemp + this.redConfirmed
        const blueTotal = this.blueTemp + this.blueConfrimed

        if (
            (this.redTemp > 0 &&
                redTotal < (this.tableLimit.downLimit as number)) ||
            (this.blueTemp > 0 &&
                blueTotal < (this.tableLimit.downLimit as number))
        )
            return BetError.BELOW_MINIMUM

        const differenceTotal = Math.abs(redTotal - blueTotal)
        if (differenceTotal > (this.tableLimit.upLimit as number))
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    checkGreenLimit(): string {
        const greenTotal = this.greenTemp + this.greenConfrimed

        if (
            this.greenTemp > 0 &&
            greenTotal < (this.tableLimit.tieDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (greenTotal > (this.tableLimit.tieUpLimit as number))
            return BetError.ABOVE_MAXIMUM
        return BetError.BET_OK
    }

    sendBetRequest(): void {
        if (this.hasPendingRequest) return
        this.hasPendingRequest = true
        const popError: PopAlertModel = {
            type: 0,
            header: '',
            message: '',
            color: ''
        }

        let _deskId = -1

        if (this.deskId !== -1) {
            _deskId = this.deskId
        } else {
            _deskId = this.currentDesk.id || 0
        }

        let _shoeNo = -1
        let _juNo = -1
        let _gameNo = ''
        if (this.deskOtherInfos) {
            _shoeNo = this.deskOtherInfos.shoeNo
            _juNo = this.deskOtherInfos.juNo
            _gameNo = this.deskOtherInfos.gameNo
        } else {
            _shoeNo = this.currentDesk.expand.shoeNo || 0
            _juNo = this.currentDesk.expand.juNo || 0
            _gameNo = this.currentDesk.expand.gameNo || ''
        }

        const _params: any = {
            token: this.token,
            memberId: this.memberId,
            shoeNo: _shoeNo,
            juNo: _juNo,
            gameNo: _gameNo,
            tableId: _deskId
        }

        if (this.redTemp > 0) _params.zhuang = this.redTemp
        if (this.blueTemp > 0) _params.xian = this.blueTemp
        if (this.greenTemp > 0) _params.he = this.greenTemp

        this.showLoading()

        saveBet(_params)
            .then(r => {
                this.hasPendingRequest = false
                this.hideLoading()
                if (r.data.status === 200) {
                    audioPlayer.Play(SOUNDKEY.BET_SUCCESS)

                    if (this.deskId !== -1) {
                        this.PopMessage('下注成功')
                    } else {
                        popError.message = '下注成功'
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
                    }

                    this.$emit('bet-success')
                    this.onBetSuccess({
                        betFormList: r.data.data.gameTable.expand.betFormList,
                        id: r.data.data.gameTable.id,
                        amount: r.data.data.gameTable.expand.amount
                    })
                    this.OnCancelBetTemp()
                } else {
                    // 投注失败，重置标志允许再次操作
                    this.hasPendingRequest = false
                    if (this.deskId !== -1) {
                        this.PopMessage(r.data.description)
                    } else {
                        popError.message = r.data.description
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
                    }
                }
            })
            .catch(() => {
                this.hasPendingRequest = false
                this.hideLoading()
                popError.message = this.t('propmt.networkerror')
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            })
    }

    ResetConfirmedTemp(): void {
        this.redConfirmedTemp = 0
        this.blueConfirmedTemp = 0
        this.greenConfirmedTemp = 0
    }

    get redFinal(): number {
        return this.redConfirmed + this.redConfirmedTemp
    }

    get blueFinal(): number {
        return this.blueConfrimed + this.blueConfirmedTemp
    }

    get greenFinal(): number {
        return this.greenConfrimed + this.greenConfirmedTemp
    }
}
